suppress ALL

<template>
	<tr>
		<td class="text-center">
			{{ user.name }}
		</td>
		<td class="text-center">
			{{ user.last_name }}
		</td>
		<td class="text-right">
			{{ user.email }}
		</td>
		<td class="text-right">
			{{ user.company && user.company.name }}
		</td>
		<td v-if="showOrganization">
			{{ user.organizations_name }}
		</td>
		<td>
			<edit-btn
				class="mx-2 my-1"
				@click="onEdit"
			/>
			<remove-btn
				class="mx-2 my-1"
				@remove="doRemove"
			/>
			<v-btn
				v-if="isAdmin"
				color="primary"
				:loading="loading"
				@click="loginAs"
			>
				כנס כמשתמש
			</v-btn>
		</td>
	</tr>
</template>

<script>

import { types } from "src/store/modules/User.module";
import RemoveBtn from "src/scaffoldings/RemoveBtn";
import EditBtn from "src/scaffoldings/EditBtn";
import RowMixin from "src/mixins/RowMixin";
import AuthService from "dev/packages/AuthService";

export default {
	name: "UserRow",
	components: { EditBtn, RemoveBtn },
	props: {
		user: { required: true },
		showOrganization: { default: false },
	},
	mixins: [new RowMixin(types, "user")],
	data () {
		return {
			loading: false,
		};
	},
	computed: {
		isAdmin () {
			return this.$store.getters.isAdmin;
		},
	},
	methods: {
		async loginAs () {
			this.loading = true;
			await AuthService.loginAs(this.user.id);
			window.location.replace("/");
		},
		doRemove () {
			this.$store.dispatch(types.REMOVE, this.user);
		},
		onEdit () {
			this.$emit("edit", this.user);
		},
	},
};
</script>

<style>

</style>
